import { IGameCategoriesState } from './gameCategoriesContext';
import { GameCategoriesActionTypes, TGameCategoriesAction } from './gameCategoriesActions';

export const gameCategoriesReducer = (
	state: IGameCategoriesState,
	action: TGameCategoriesAction,
): IGameCategoriesState => {
	switch (action.type) {
		case GameCategoriesActionTypes.SET_GAME_CATEGORIES:
			return {
				...state,
				gameCategories: action.payload.gameCategories,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameCategoriesActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case GameCategoriesActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				currentPage: 1,
			};
		case GameCategoriesActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case GameCategoriesActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case GameCategoriesActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case GameCategoriesActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameCategoriesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameCategoriesActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
